import { Address, Cell, Dictionary } from "@ton/core";
import { Master as Lending } from "../../lib/wrappers/Lending";
import { Helper as LendingHelper } from "../../lib/wrappers/LendingHelper";
import { INFTItem } from "../NFT/NFTTypes";

export type LendingType = Lending;

export type LendingHelperType = LendingHelper;

export type LendingDateTabType =
  // | "15min"
  | "1day"
  | "3days"
  | "7days"
  | "14days"
  | "30days"
  | "60days"
  | "90days"
  | "120days";

export enum LendingDateTab {
  // "15min" = "15min",
  "1day" = "1day",
  "3days" = "3days",
  "7days" = "7days",
  "14days" = "14days",
  "30days" = "30days",
  "60days" = "60days",
  "90days" = "90days",
  "120days" = "120days",
}

export type LendingAPRTabType = 0.01 | 0.02 | 0.03 | 0.04 | 0.05;

export interface ILendingContractData {
  owner: Address;
  nft: Address;
  jettonWallet: Address;
  active: bigint;
  offerAccept: bigint;
  offers: Dictionary<Address, bigint>;
  amount: bigint;
  loanDuration: bigint;
  aprAmount: bigint;
  helperCode: Cell;
  platform: Address;
  platformFee: bigint;
  currentHelperId: bigint;
}

export interface ILendingHelperContractData {
  isActive: boolean;
  helperId: bigint;
  master: Address;
  jettonWallet: Address;
  ownerJettonWallet: Address;
  paidAmount: bigint;
  owner: Address;
  masterOwner: Address;
  platform: Address;
  amount: bigint;
  loanDuration: bigint;
  aprAmount: bigint;
  accepted: bigint;
  offerLoanDuration: bigint;
  offerAprAmount: bigint;
  offerExtraReward: bigint;
  offerTurn: Address;
}

export interface ILending {
  id: number;
  address: string;
  ownerAddress: string;
  nftAddress: string;
  lenderAddress: string;
  amount: string;
  nft: INFTItem;
  nftId: number;
  collectionId: number;
  created: string;
  versionHash: string;
  lastCheckedAt: string;
  contractData: ILendingContractDataFromServer;
  status: LendingStatus;
  accepted: string;
  closeDate: string;
  offerAddress: string;
}

export interface ILendingContractDataFromServer {
  active: boolean;
  amount: string;
  aprAmount: string;
  contractType: number;
  jettonWallet: string;
  loanDuration: string;
  nft: string;
  offerAccept: boolean;
  offers: string[];
  owner: string;
  platform: string;
  version: string;
  versionHash: string;
}

export enum LendingStatus {
  ACTIVE = "ACTIVE",
  ACCEPTED = "ACCEPTED",
  IN_CHECK = "IN_CHECK",
  ENDED = "ENDED",
  CANCELED = "CANCELED",
  ERROR = "ERROR",
  WITHOUT_NFT = "WITHOUT_NFT",
  RETURNED_NFT = "RETURNED_NFT",
}

export interface IGetOwnerAggsLendingsResponse {
  collections: {
    collectionAddress: string;
    count: number;
  }[];
  statuses: {
    status: LendingPageStatus;
    count: number;
  }[];
  durations: {
    duration: number;
    count: number;
  }[];
}

export enum LendingPageStatus {
  active = "active",
  overdue = "overdue",
  auction = "auction",
  repaid = "repaid",
}

export const enum LendingsSortType {
  amountAsc = "amount_asc",
  amountDesc = "amount_desc",
  createdAsc = "created_asc",
  createdDesc = "created_desc",
}

export enum LendingsOwnershipType {
  all = "All",
  asBorrower = "As a borrower",
  asLender = "As a lender",
}
